import { API, apiRequest } from './api';
import { ApiError } from './errors';

async function parseJsonIfPresent(response) {
  const contentType = response.headers.get('Content-Type');
  if (contentType && contentType.includes('application/json')) {
    return await response.json();
  }
  return null;
}

/**
 * TempService
 *
 * Anonymous, no-login flow helpers for creating a temporary survey response and
 * initiating an embedded Stripe Checkout session for it.
 */
export async function createTempAnonSurvey({
  startTime,
  completionTime,
  responses,
}) {
  try {
    const response = await apiRequest(API.ANON_SURVEY_TEMP, {
      method: 'POST',
      body: { startTime, completionTime, responses },
    });
    return (await parseJsonIfPresent(response)) ?? {};
  } catch (e) {
    console.error('Error creating anonymous temp survey:', e);
    if (e?.name === 'ApiError') throw new ApiError('anonTempSurvey', e.status);
    throw e;
  }
}

export async function initiateTempAnonSurveyPurchase({ tempId, price }) {
  if (!tempId) throw new Error('tempId is required.');

  try {
    const response = await apiRequest(API.ANON_SURVEY_TEMP_INITIATE_PURCHASE, {
      method: 'POST',
      body: { tempId, price },
    });
    return (await parseJsonIfPresent(response)) ?? {};
  } catch (e) {
    console.error('Error initiating anonymous temp purchase:', e);
    if (e?.name === 'ApiError')
      throw new ApiError('anonTempSurveyPurchase', e.status);
    throw e;
  }
}
